import { useEffect, useState } from 'react';

/** 新版本发布后旧资源失效时派发的全局事件名 */
export const VERSION_UPDATE_EVENT = 'app:version-update';

/**
 * 版本更新确认弹框：
 * 监听全局事件（路由懒加载 chunk 因新版本发布加载失败时派发），
 * 提示用户系统已更新，点击确认后刷新页面加载最新版本。
 */
export default function VersionUpdateModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener(VERSION_UPDATE_EVENT, handler);
    return () => window.removeEventListener(VERSION_UPDATE_EVENT, handler);
  }, []);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40">
      <div className="bg-background-50 rounded-2xl p-6 max-w-sm w-full mx-4 shadow-xl">
        <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-4">
          <i className="ri-refresh-line text-accent-600 text-lg" />
        </div>
        <p className="text-sm font-semibold text-foreground-900 text-center mb-1">检测到新版本更新</p>
        <p className="text-xs text-foreground-500 text-center mb-5 leading-relaxed">
          系统已发布新版本，请刷新页面以获取最新内容
        </p>
        <button
          onClick={() => window.location.reload()}
          className="w-full py-2 rounded-xl text-xs font-medium bg-accent-500 text-primary-950 hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-refresh-line mr-1" />确认刷新
        </button>
      </div>
    </div>
  );
}
